import { render } from "./productCatlogBroswer.vue?vue&type=template&id=00f5e897&scoped=true"
import script from "./productCatlogBroswer.vue?vue&type=script&lang=js"
export * from "./productCatlogBroswer.vue?vue&type=script&lang=js"

import "./productCatlogBroswer.vue?vue&type=style&index=0&id=00f5e897&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f5e897"]])

export default __exports__